import React, { useState } from "react";

const EXPAND_THRESHOLD = 170;

const getQuoteId = (author) =>
  `testimonial-${author.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

const TestimonialCard = ({ testimonial }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isLongReview = testimonial.quote.length > EXPAND_THRESHOLD;
  const quoteId = getQuoteId(testimonial.author);

  return (
    <article
      className={`testimonial-card${
        isExpanded ? " testimonial-card--expanded" : ""
      }`}
    >
      <div className="testimonial-card__rating" aria-label="5 star review">
        <span aria-hidden="true">★★★★★</span>
      </div>

      <p
        className={`testimonial-card__quote${
          isLongReview && !isExpanded ? " testimonial-card__quote--collapsed" : ""
        }`}
        id={quoteId}
      >
        “{testimonial.quote}”
      </p>

      <div className="testimonial-card__footer">
        <span className="testimonial-card__author">{testimonial.author}</span>
        {isLongReview && (
          <button
            aria-controls={quoteId}
            aria-expanded={isExpanded}
            className="testimonial-card__toggle"
            onClick={() => setIsExpanded((current) => !current)}
            type="button"
          >
            {isExpanded ? "Show less" : "Read full review"}
          </button>
        )}
      </div>
    </article>
  );
};

export default TestimonialCard;
